export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Home',
    garage: 'Garage Systems',
    villa: 'Villa Projects',
    winter: 'Winter Garden',
    projects: 'Projects',
    about: 'About Us',
    contact: 'Contact',
    cta: 'Get a Quote for Your Project',
  },
  hero: {
    title1: 'Premium Garage Systems',
    title2: 'That Add Value to Your Villa',
    subtitle: 'Architecturally tailored premium enclosed garage solutions for luxury villa projects and private villas.',
    cta1: 'Get a Quote for Your Project',
    cta2: 'Explore Garage Systems',
    small: '1 & 2 Car Systems • Custom Architectural Design • Project-Based Solutions',
  },
  s1: {
    title: 'A Garage Should Not Be an Afterthought to Your Villa.',
    text: 'VILLAGARAGE treats the garage not as a standalone structure, but as an integral part of the villa’s architecture.',
    f1: 'Architecturally tailored design',
    f2: 'Premium appearance',
    f3: 'All-season vehicle protection',
  },
  s2: {
    title: 'Same Villa. A Different Standard of Living.',
    openTitle: 'Open Parking',
    openDesc: 'Vehicle exposed to the elements. Lacks architectural integrity. Adds no value to the project.',
    garageTitle: 'VILLAGARAGE Premium Garage',
    garageDesc: 'Vehicle protected all year. Integrates with the villa’s architecture. Adds premium value to the project.',
    cta: 'Request a Solution for Your Project',
  },
  s3: {
    title: 'Garage Systems',
    cta: 'Explore',
    card1: {
      title: 'Single-Car Premium Garage',
      desc: 'A compact, elegant, architecturally tailored premium garage for a single vehicle.',
    },
    card2: {
      title: 'Double-Car Premium Garage',
      desc: 'A spacious, airy premium garage that integrates seamlessly with your villa for two vehicles.',
    },
    card3: {
      title: 'Project-Specific Garage Systems',
      desc: 'Bespoke solutions designed around villa projects and unique requirements.',
    },
  },
  s4: {
    title1: 'No Two Villas Are Alike.',
    title2: 'Neither Should Their Garages Be.',
    d1: 'Anthracite architectural systems',
    d2: 'Natural wood details',
    d3: 'Architectural lighting',
    d4: 'Custom facade designs',
    d5: '1 & 2 car solutions',
  },
  s5: {
    title: 'A Detail That Sets Villa Projects Apart',
    subtitle: 'VILLAGARAGE for construction companies, project developers, and architects.',
    b1: 'Project-specific design',
    b2: 'Integration with villa architecture',
    b3: 'Structure suited to multi-villa projects',
    b4: 'Premium project perception',
    b5: 'Single / double car solutions',
    b6: 'A systems approach as an alternative to traditional heavy construction',
    cta: 'Submit Your Villa Project',
  },
  s6: {
    title: 'Don’t Leave Your Million-Dollar Car Exposed All Year.',
    text: 'Create a more protected premium space against sun, rain, hail, snow, and external factors.',
    cta: 'I Want a Garage for My Villa',
  },
  s7: {
    title: 'Holistic Architectural Solutions for Your Villa',
    subtitle: 'Premium Garage + Winter Garden',
    cta: 'Request Information for My Project',
  },
  s8: {
    title: 'How Does Your Project Begin?',
    step1: 'Share Your Space',
    step1d: 'Send us the essential details about your villa or project.',
    step2: 'Define the Need',
    step2d: 'Let’s clarify vehicle capacity and usage scenarios together.',
    step3: 'Design Approach',
    step3d: 'Let’s develop a bespoke design approach suited to your architecture.',
    step4: 'Quote',
    step4d: 'Let’s provide you with a tailored quote based on project scope.',
    step5: 'Implementation',
    step5d: 'After approval, let’s carry out the implementation as planned.',
  },
  s9: {
    title: 'Inspiring Garage Projects',
    filterAll: 'All',
    filterSingle: 'Single-Car',
    filterDouble: 'Double-Car',
    filterVilla: 'Villa Projects',
    filterWinter: 'Winter Garden',
  },
  s10: {
    title: 'Let’s Design a Custom Solution for Your Villa or Project.',
  },
  form: {
    name: 'Full Name',
    namePh: 'Your full name',
    phone: 'Phone',
    phonePh: '+90 5xx xxx xx xx',
    email: 'Email',
    emailPh: 'example@email.com',
    city: 'City',
    cityPh: 'Your city',
    customerType: 'Customer Type',
    solution: 'Solution You’re Interested In',
    projectStatus: 'Project / Land Status',
    message: 'Message',
    messagePh: 'Briefly describe your project...',
    upload: 'Image Upload',
    uploadHint: 'You can upload land, villa, or reference images',
    submit: 'SUBMIT MY PROJECT',
    success: 'Your request has been received. We will contact you shortly.',
    error: 'Something went wrong. Please try again.',
    customer: {
      villaOwner: 'Villa Owner',
      construction: 'Construction Company',
      developer: 'Project Developer',
      architect: 'Architect',
      investor: 'Investor',
      other: 'Other',
    },
    solutionOpt: {
      single: 'Single-Car Garage',
      double: 'Double-Car Garage',
      villaProject: 'Villa Project',
      winterGarden: 'Winter Garden',
      combined: 'Garage + Winter Garden',
      custom: 'Custom Project',
    },
    status: {
      land: 'Have land / plot',
      construction: 'Villa under construction',
      existing: 'Existing villa',
      none: 'No land yet',
      other: 'Other',
    },
  },
  whatsapp: {
    message: 'Hello VILLAGARAGE, I would like to get information and a quote for my villa / garage project.',
  },
  mobile: {
    cta: 'Request Information for Your Project',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'Can it be applied to existing villas?',
    a1: 'Yes. We offer solutions suited to both newly built and existing villas. For existing villas, a project-specific implementation is carried out after assessing the space and architectural structure.',
    q2: 'Are single and double car systems available?',
    a2: 'Yes, our single-car and double-car premium garage systems are available. We also develop project-specific multi-solutions.',
    q3: 'Is the same model applied to every villa?',
    a3: 'No. Each project is custom-designed according to the villa’s architecture, dimensions, and the client’s needs; no standard model is used.',
    q4: 'Do you work on multi-villa projects?',
    a4: 'Yes, we work with construction companies and project developers on multi-villa projects, offering project-based custom solutions.',
    q5: 'Can a winter garden also be built?',
    a5: 'Yes. In addition to garage systems, we offer winter garden and integrated garage + winter garden solutions.',
    q6: 'How is pricing determined?',
    a6: 'Pricing is determined based on dimensions, vehicle capacity, architectural details, material preferences, and project scope.',
    q7: 'How can I submit my project?',
    a7: 'You can fill out the form on our website, reach us via WhatsApp (+90 544 110 14 92), or send a message via Instagram (@villagarage90).',
  },
  about: {
    title: 'About Us',
    text: 'VILLAGARAGE is a brand that develops architectural solutions for premium villa garages and outdoor living spaces. It treats the garage not as a standalone structure but as an integral part of the villa’s architecture, adding lasting value to living spaces through anthracite systems, natural wood details, and custom facade designs. Working with villa owners, architects, contractors, and project developers, it delivers premium solutions tailored to every need and integrated with the architecture.',
  },
  final: {
    title: 'Complete Your Villa’s Architecture with Your Garage.',
    cta1: 'Get a Quote for Your Project',
    cta2: 'Contact Us on WhatsApp',
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menu',
    contactTitle: 'Contact',
    instagram: 'Instagram',
    copyright: 'All rights reserved.',
  },
};